import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { SessionService } from '../../../Util/Session/session.service';
import { Toast, ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import moment from 'moment';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-expense-form-item',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDropdownModule, NgSelectModule, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './expense-form-item.component.html',
  styleUrl: './expense-form-item.component.scss'
})
export class ExpenseFormItemComponent {
  isDisabled: boolean = false;

  @Input() TravelType: string = '';
  @Input() TripMasterId: number = 0;
  @Input() StartDate: any = null;
  @Input() EndDate: any = null;
  @Input() ESS_ExpenseRequestMainId: any = null;

  Categorys = [] as any;
  Vehicles = [] as any;
  CategoryVehiclesAll = [] as any;
  CategoryVehicles = [] as any;
  //Classs = [] as any;
  user = [] as any;
  uploadevene = null as any;

  Data = {
    SelectType: 'i',
    ESS_ExpenseRequestMainId: null,
    EmpMasterId: 0,
    TravelType: null as any,
    TripMasterId: null as any,
    ESS_ExpenseRequestDetailsId: null,
    ExpenseDate: null as any,
    ExpenseDateObj: null as any,
    CategoryVehiclesID: null,
    ESS_VehicleMasterId: null,
    ESS_ExpenseCategoryMasterId: null as any,
    //ESS_ExpenseClassDetailsId: null,
    Kilometers: null,
    Description: null,
    Rate: null as any,
    ExpenseAmount: null as any,
    FromLocation: null,
    ToLocation: null,
    Merchant: null,
    Attachment: null,
    AttachmentURL: null as any,
    ReportName: null,
    FromDate: null,
    ToDate: null,
    ReportDesc: null,
    ESS_ExpenseRequestDetailsIds: null,
    AtActual: false,
    IsCategory: true,
  }

  constructor(
    private activeModal: NgbActiveModal,
    private expense: ExpenseService,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
    protected sanitizer: DomSanitizer,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.Data.TravelType = this.TravelType;
    this.SelectDate('RegistrationDate', null, null);
    if (this.common.ToLowerCase(this.Data.TravelType) == 'outstation') {
      this.Data.TripMasterId = this.TripMasterId;
      this.Data.ESS_ExpenseRequestMainId = this.ESS_ExpenseRequestMainId;

      if (this.ESS_ExpenseRequestMainId != null && this.ESS_ExpenseRequestMainId > 0) {
        this.Data.SelectType = 'u';
      }
    }
    this.ESS_ExpenseRequest_ComboLoad('Category');
    this.ESS_ExpenseRequest_ComboLoad('Vehicle');
    this.Data.EmpMasterId = this.user.UserId;
  }

  Verification(form: any) {
    if (form.valid) {
      this.ESS_ExpenseRequestInsert()
    }
    else {
      form.submitted = true;
    }
  }

  ESS_ExpenseRequest_ComboLoad(SelectType: String) {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRequest_ComboLoad({ SelectType: SelectType, EmpMasterId: this.user.UserId, TravelType: this.Data.TravelType }).subscribe({
      next: (response) => {
        if (this.common.ToLowerCase(SelectType) == 'category') {
          this.Categorys = response;

          const categories = response.Table.map((element: any, index: number) => ({
            ID: this.CategoryVehiclesAll.length + index + 1,
            CategoryVehicleID: element.ESS_ExpenseCategoryMasterID,
            CategoryVehicle: element.ExpenseCategoryName,
            IsCategory: true
          }));

          this.CategoryVehiclesAll.push(...categories);
          this.CategoryVehicles = [...this.CategoryVehiclesAll];
        } else if (this.common.ToLowerCase(SelectType) == 'vehicle') {
          this.Vehicles = response
          const vehicles = response.Table.map((element: any, index: number) => ({
            ID: this.CategoryVehiclesAll.length + index + 1,
            CategoryVehicleID: element.ESS_VehicleMasterID,
            CategoryVehicle: element.VehicleName,
            IsCategory: false
          }));

          this.CategoryVehiclesAll.push(...vehicles);
          this.CategoryVehicles = [...this.CategoryVehiclesAll];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  getClass() {
    this.Data.ESS_VehicleMasterId = null;
    this.Data.ESS_ExpenseCategoryMasterId = null;
    //this.Data.ESS_ExpenseClassDetailsId = null;
    this.Data.Kilometers = null;
    this.Data.Rate = null;
    this.Data.ExpenseAmount = null;
    this.Data.AtActual = false;
    this.Data.IsCategory = this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].IsCategory ?? false;

    //this.Classs = [];
    if (this.Data.CategoryVehiclesID != null && this.Data.CategoryVehiclesID > 0) {
      if (this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].IsCategory) {
        this.Data.ESS_VehicleMasterId = null;
        this.Data.ESS_ExpenseCategoryMasterId = this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].CategoryVehicleID;
        this.Data.Kilometers = null;
        this.Data.Rate = null;
        //this.Data.AtActual = this.Categorys.Table.filter((e: any) => e.ESS_ExpenseCategoryMasterID == this.Data.ESS_ExpenseCategoryMasterId)[0].AtActual;

        // this.Classs = this.Categorys.Table1.filter((e: any) => e.ESS_ExpenseCategoryMasterId == this.Data.ESS_ExpenseCategoryMasterId).map((element: any, index: number) => ({
        //   ESS_ExpenseClassDetailsId: element.ESS_ExpenseClassDetailsId,
        //   ClassName: element.ClassName,
        // }));

        this.ESS_ExpenseRequest_ComboLoadData('CategoryDet');
      } else {
        this.Data.ESS_VehicleMasterId = this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].CategoryVehicleID;
        this.Data.ESS_ExpenseCategoryMasterId = null;
        this.Data.Kilometers = null;

        //this.Data.Rate = this.Vehicles.Table.filter((e: any) => e.ESS_VehicleMasterID == this.Data.ESS_VehicleMasterId)[0].MileageRate;
        //this.Data.AtActual = this.Vehicles.Table.filter((e: any) => e.ESS_VehicleMasterID == this.Data.ESS_VehicleMasterId)[0].AtActual;

        // this.Classs = this.Vehicles.Table1.filter((e: any) => e.ESS_VehicleMasterId == this.Data.ESS_VehicleMasterId).map((element: any, index: number) => ({
        //   ESS_ExpenseClassDetailsId: element.ESS_ExpenseClassDetailsId,
        //   ClassName: element.ClassName,
        // }));

        this.ESS_ExpenseRequest_ComboLoadData('VehicleDet');
      }
    }
  }

  ESS_ExpenseRequest_ComboLoadData(SelectType: String) {
    this.isDisabled = true;
    this.expense.ESS_ExpenseRequest_ComboLoad({
      SelectType: SelectType, EmpMasterId: this.user.UserId, TravelType: this.Data.TravelType, ESS_VehicleMasterId: this.common.ToLowerCase(SelectType) == 'vehicledet' ? this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].CategoryVehicleID : 0
      , ESS_ExpenseCategoryMasterId: this.common.ToLowerCase(SelectType) == 'categorydet' ? this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].CategoryVehicleID : 0,
      ExpenseDate: this.dateFormat.format(this.Data.ExpenseDateObj)
    }).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          if (this.common.ToLowerCase(SelectType) == 'categorydet') {
            this.Data.AtActual = response.Table[0].AtActual;
          } else if (this.common.ToLowerCase(SelectType) == 'vehicledet') {
            this.Data.Rate = response.Table[0].MileageRate;
            this.Data.AtActual = response.Table[0].AtActual;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CalAmount() {
    if (this.Data.Kilometers != null && this.Data.Kilometers > 0) {
      this.Data.ExpenseAmount = this.Data.Kilometers * this.Data.Rate;
    } else {
      this.Data.ExpenseAmount = 0;
    }
  }

  upload(event: any, Folder: any) {
    try {
      if ((event.currentTarget.accept).includes(event.target.files[0].type.split('/')[1]) || event.target.files[0].type.split('/')[1].split('.').findIndex((e:any) => e == 'sheet') >= 0) {
        const file = event.target.files[0];
        if (file) {
          const fileSizeInBytes = file.size; // File size in bytes
          const fileSizeInKB = fileSizeInBytes / 1024;
          if (!this.common.fileupload.checkSize || fileSizeInKB <= this.common.fileupload.size) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              this.UploadServices(Folder, reader.result);
              this.uploadevene = event;
            };
          } else {
            this.toast.show({ message: 'Max Upload Size is 1024KB Only!', type: toastTypeEnum.danger });
            event.target.value = null;
          }
        }
      } else {
        this.toast.show({ message: 'selected file not allow, allow file only ' + event.currentTarget.accept, type: toastTypeEnum.danger });
        event.target.value = null;
      }
    } catch (e) { }
  }

  UploadServices(Folder: string, Base64: any) {
    this.isDisabled = true;
    this.utility.Upload({ 'DomainName': this.user.Domain, 'folder': Folder, 'CompanyCode': this.user.CompanyCode, 'FileBase64': Base64 }).subscribe((response: any) => {
      if (response.FileName != "") {
        if (Folder == this.common.CompanyParameterValue.ExpenseFolder) {
          this.Data.Attachment = response.FileName;
          this.Data.AttachmentURL = response.Url;
        }
      } else {
        this.toast.show({ message: 'Image not uploaded', type: toastTypeEnum.warning });
      }
      this.isDisabled = false;
    }, (error) => {
      this.isDisabled = false;
    });
  }

  ESS_ExpenseRequestInsert() {
    if (this.common.ToLowerCase(this.Data.TravelType) == 'local' || (this.common.ToLowerCase(this.Data.TravelType) == 'outstation' && (moment(this.dateFormat.format(this.EndDate), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.StartDate), 'DD MMM YYYY'))))) {
      if (this.Data.ExpenseAmount == null || this.Data.ExpenseAmount == '' || this.Data.ExpenseAmount <= 0) {
        this.toast.show({ message: 'Please enter amount greater then 0', type: toastTypeEnum.warning });
      }
      //  else if (this.Data.ESS_ExpenseCategoryMasterId > 0 &&
      //   this.Categorys.Table.filter((e: any) => e.ESS_ExpenseCategoryMasterID == this.Data.ESS_ExpenseCategoryMasterId)[0].IsReceiptRequired &&
      //   this.Categorys.Table.filter((e: any) => e.ESS_ExpenseCategoryMasterID == this.Data.ESS_ExpenseCategoryMasterId)[0].ReceiptRequiredLimit > this.Data.ExpenseAmount &&
      //   (this.Data.Attachment == null || this.Data.Attachment == '')
      // ) {
      //   this.toast.show({ message: 'Please attachment expense receipt', type: toastTypeEnum.warning });
      // } 
      else {
        const modalRef = this.modalService.open(ConfirmationComponent);
        modalRef.componentInstance.Message = 'Do you want to save?';
        modalRef.result.then(result => {
          if (result) {
            this.isDisabled = true;
            this.Data.ExpenseDate = this.dateFormat.format(this.Data.ExpenseDateObj)
            this.expense.ESS_ExpenseRequestInsert(this.Data).subscribe({
              next: (response) => {
                if (response.Error_Code == "480") {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.activeModal.close(true);
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        });
      }
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  RemoveAttachment() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to remove?';
    modalRef.result.then(result => {
      if (result) {
        this.Data.Attachment = null;
        this.Data.AttachmentURL = null;
        this.uploadevene.target.value = null;
      }
    });
  }

  close() {
    this.activeModal.close();
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Data.ExpenseDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  ClearData() {
    this.Data.Kilometers = null;
    this.Data.Rate = null;
    this.Data.ExpenseAmount = null;
    this.Data.AtActual = false;

    if (this.Data.CategoryVehiclesID != null && this.Data.CategoryVehiclesID > 0) {
      if (this.CategoryVehicles.filter((e: any) => e.ID == this.Data.CategoryVehiclesID)[0].IsCategory) {
        this.ESS_ExpenseRequest_ComboLoadData('CategoryDet');
      } else {
        this.ESS_ExpenseRequest_ComboLoadData('VehicleDet');
      }
    }
  }
}
